module.exports = __webpack_public_path__ + "img/atendimento.07cfb1fc.svg";